define('Moment', [
  'MomentBase',
  'MomentDurationFormat',
  'MomentHoliday',
  'MomentHoliday.UnitedStates',
  'MomentTimezone'
], function Moment(
  moment,
  momentDurationFormat
) {
  'use strict';

  momentDurationFormat(moment);

  return moment;
});
